import React from 'react';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

export default function FanInfoPanel() {
  const { fan } = useMembershipShowContext();
  if (!fan) return null;

  const location = [fan.city, fan.state].filter(Boolean).join(', ');
  const phone = fan.human_phone || '—';

  return (
    <div className="team-member-card mb-3 h-100">
      <div className="team-member-card-header">
        <div className="team-member-card-header-left">
          <div className="team-member-card-title-row">
            <h2 className="team-member-card-title">Fan Info</h2>
          </div>
        </div>
      </div>
      <div className="team-member-card-body">
        <dl className="row mb-0">
          <dt className="col-4">Email</dt><dd className="col-8">{fan.email || '—'}</dd>
          <dt className="col-4">Phone</dt><dd className="col-8">{phone}</dd>
          <dt className="col-4">Location</dt><dd className="col-8">{location || '—'}</dd>
        </dl>
      </div>
    </div>
  );
}
